import React from "react";
import useIsMobile from "../hooks/useIsMobile";
import AuditDashboardMobile from "../mobile/audit/AuditDashboardMobile";
import AuditDashboard from "./AuditDashboard";
export default function ResponsiveAuditDashboard(props) { return useIsMobile() ? <AuditDashboardMobile {...props} /> : <AuditDashboard {...props} />; }
